export default {"src":"/_next/static/media/heart-filled-red-46x46.377a64db.svg","height":19,"width":22};